const runSeoEventData = seoEventData => {
  if (window.onSeoUserEvent && seoEventData) {
    try {
      const payload = JSON.parse(seoEventData);
      const { type, data } = payload;
      window.onSeoUserEvent(type, data);
    } catch (e) {
      console.log(
        'onSeoUserEvent failed - please check the CTA button JSON and that a SeoInteractionScript is correctly set up.'
      );
    }
  }
  return;
};

export default runSeoEventData;
